// node modules
import React, { FC } from 'react';
// ui-library
import { View, Text, useThemeDetector } from '@upstox/upstox-ui';
// modules
import Format from 'modules/Format';
import { useStore } from 'modules/Stores';
// typings
import { ReleaseNotesItem } from 'modules/ReleaseNotes/typings';
// styles
import * as css from './styles';

const ReleaseNoteCard: FC<ReleaseNotesItem> = props => {
  const { title, description, date, image, link } = props;
  const { theme } = useStore('AppStore');
  const autoTheme = useThemeDetector();
  const currentTheme = theme === 'auto' ? autoTheme : theme;
  const isDarkTheme = currentTheme === 'dark';

  return (
    <View
      as="a"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      flexDirection="column"
      gap="large"
      css={css.releaseNoteCard}
      cssProps={{ isDarkTheme }}
    >
      <View
        flexDirection="column"
        gap="small"
      >
        <View>
          <Text css={css.date} cssProps={{ isDarkTheme }}>
            {Format.formatDate(date, 'MMM_DD_YYYY')}
          </Text>
        </View>
        <View>
          <Text className="releaseNoteCardTitle" css={css.title} cssProps={{ isDarkTheme }}>
            {title}
          </Text>
        </View>
        <View>
          <Text css={css.description} cssProps={{ isDarkTheme }}>
            {description}
          </Text>
        </View>
      </View>
      <View>
        <img style={css.imageStyle} src={image} alt={title} />
      </View>
    </View>
  );
};

export default ReleaseNoteCard;
